import { Listing } from '../../../types';
import { rankByCompleteness } from '../../../utils/listingCompleteness.mjs';

/**
 * Sorts listings based on the provided sort option.
 * Always prioritizes featured listings first.
 */
export function sortListings(listings: Listing[], sortOption?: string): Listing[] {
    // Relevance ranks the whole set once (the comparator is shared with the
    // prerenderer), then the featured-first rule below reorders around it.
    const sorted = sortOption === 'relevance'
        ? (rankByCompleteness(listings) as Listing[])
        : [...listings];

    sorted.sort((a, b) => {
        // Featured first (always priority 1)
        if (a.isFeatured !== b.isFeatured) {
            return a.isFeatured ? -1 : 1;
        }

        // Secondary sorting
        switch (sortOption) {
            case 'price_asc': {
                const pa = a.spaceDetails?.pricePerHour || a.price || 0;
                const pb = b.spaceDetails?.pricePerHour || b.price || 0;
                return pa - pb;
            }
            case 'price_desc': {
                const pa = a.spaceDetails?.pricePerHour || a.price || 0;
                const pb = b.spaceDetails?.pricePerHour || b.price || 0;
                return pb - pa;
            }
            // Best-documented first. The worker cannot do this: completeness
            // is derived from the space_details JSON, so it is resolved here
            // over the rows the worker already returned.
            case 'relevance':
                // Already ordered above; keep it stable here.
                return 0;
            case 'newest':
            default: {
                const da = new Date(a.createdAt || 0).getTime();
                const dbb = new Date(b.createdAt || 0).getTime();
                return dbb - da;
            }
        }
    });

    return sorted;
}
